// Shared body zones (front view). Coords in a 300x600 viewBox.
export const ZONES = [
  { id: "head", x: 150, y: 45, r: 30, en: "Head", fr: "Tête" },
  { id: "neck", x: 150, y: 90, r: 12, en: "Neck", fr: "Cou" },
  { id: "shoulder_l", x: 105, y: 115, r: 16, en: "L Shoulder", fr: "Épaule G" },
  { id: "shoulder_r", x: 195, y: 115, r: 16, en: "R Shoulder", fr: "Épaule D" },
  { id: "chest", x: 150, y: 145, r: 22, en: "Chest", fr: "Poitrine" },
  { id: "abs", x: 150, y: 195, r: 20, en: "Core", fr: "Tronc" },
  { id: "hip_l", x: 125, y: 245, r: 15, en: "L Hip", fr: "Hanche G" },
  { id: "hip_r", x: 175, y: 245, r: 15, en: "R Hip", fr: "Hanche D" },
  { id: "thigh_l", x: 122, y: 305, r: 18, en: "L Thigh", fr: "Cuisse G" },
  { id: "thigh_r", x: 178, y: 305, r: 18, en: "R Thigh", fr: "Cuisse D" },
  { id: "knee_l", x: 122, y: 385, r: 14, en: "L Knee", fr: "Genou G" },
  { id: "knee_r", x: 178, y: 385, r: 14, en: "R Knee", fr: "Genou D" },
  { id: "calf_l", x: 122, y: 445, r: 16, en: "L Calf", fr: "Mollet G" },
  { id: "calf_r", x: 178, y: 445, r: 16, en: "R Calf", fr: "Mollet D" },
  { id: "ankle_l", x: 122, y: 510, r: 11, en: "L Ankle", fr: "Cheville G" },
  { id: "ankle_r", x: 178, y: 510, r: 11, en: "R Ankle", fr: "Cheville D" },
  { id: "foot_l", x: 122, y: 550, r: 13, en: "L Foot", fr: "Pied G" },
  { id: "foot_r", x: 178, y: 550, r: 13, en: "R Foot", fr: "Pied D" },
];

export const zoneLabel = (id, lang = "en") => {
  const z = ZONES.find((z) => z.id === id);
  return z ? z[lang] || z.en : id;
};
